<template>
  <div>
    <a-card
      size="small"
      title="查询"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <a-form layout="inline" style="text-align:center;">
        <a-form-item>
          <df-selectChannelShop
            @setValue="searchAction()"
            :model="searchForm"
          ></df-selectChannelShop>
        </a-form-item>
        <a-form-item>
          <a-input
            v-model:value="searchForm.code"
            allowClear
            @keyup.enter.native="searchAction()"
            :placeholder="'请输入' + codeType"
          >
            <template v-slot:addonBefore>
              <a-select v-model:value="codeType" style="width: 100px">
                <a-select-option value="订单编号"> 订单编号 </a-select-option>
                <a-select-option value="顾客姓名"> 顾客姓名 </a-select-option>
                <a-select-option value="电话号码"> 电话号码 </a-select-option>
              </a-select>
            </template>
          </a-input>
        </a-form-item>

        <a-form-item>
          <df-selectStationList
            :region="searchForm.from"
            @setValue="setValue"
          ></df-selectStationList>
        </a-form-item>
        <a-form-item> -- </a-form-item>
        <a-form-item>
          <df-selectStationList
            :title="'终到站'"
            :region="searchForm.to"
            @setValue="setValue"
          ></df-selectStationList>
        </a-form-item>

        <a-form-item>
          <a-range-picker
            v-model:value="searchForm.date"
            :placeholder="['出票开始', '出票结束']"
            valueFormat="YYYY-MM-DD"
            format="YYYY-MM-DD"
          />
        </a-form-item>

        <a-form-item>
          <a-range-picker
            v-model:value="searchForm.orderdate"
            :placeholder="['下单开始', '下单结束']"
            valueFormat="YYYY-MM-DD"
            format="YYYY-MM-DD"
          />
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="searchAction"> 查询 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="reset">重置</a-button>
        </a-form-item>
        <!-- <a-form-item>
          <a-button class="mr" @click="openModal()">添加</a-button>
        </a-form-item> -->
       <!-- <a-form-item>
          <a-button class="mr" type="primary" @click="exports"> 导出 </a-button>
        </a-form-item>-->
        <a-form-item>
          <a-button @click="createBill">导入</a-button>
        </a-form-item>
      </a-form>
    </a-card>

    <!-- <a-card
      size="small"
      title=""
      :defaultActiveTabKey="activeKey"
      style="margin-top: 20px"
      @tabChange="cardtabChange"
      class="log_content"
      :headStyle="{
        background: '#f3f3f3',
      }"
      :bodyStyle="{
        padding: '0',
      }"
      :tabList="panes"
    > -->
    <!-- <template v-slot:extra>
        <div slot="tabBarExtraContent">
          <a-button type="danger">暂停自动出票</a-button>
        
          <a-tag color="pink" closable  style='margin-left:5px'>
              宝贝格子
          </a-tag>
          <a-tag color="pink" closable >
              两把铲子
          </a-tag>
          
        </div>
      </template> -->
    <!-- @close="log -->

    <a-table
      :columns="columns"
      bordered
      :data-source="list"
      :pagination="false"
      :scroll="{ x: 1300 }"
      :row-key="(r) => r.id"
      :loading="loading"
    >
      <template v-slot:orderCode="{ text, record }">
        <div style="color: #464c5b; cursor: pointer" @click="toDetail(record)">
          {{ record.orderCode }}
        </div>
      </template>

      <template v-slot:train="{ text, record }">
        <div>
          {{ record.fromStation }} -> {{ record.toStation
          }}<span style="color: red; margin-left: 10px"
            >({{ record.trainNo }})</span
          >
        </div>
        <div>
          {{ record.fromTimeFormat }}&nbsp;&nbsp; - &nbsp;&nbsp;{{
            record.toTimeFormat
          }}
        </div>
      </template>

      <template v-slot:passengersList="{ text, record }">
        <a-table
          :columns="columnsInner"
          bordered
          :data-source="record.passengersList"
          :pagination="false"
          :showHeader="false"
          :row-key="(r) => r.id"
        >
          <template v-slot:site="{ text, record }">
            {{ record.lastCoach }}/{{ record.lastSeat }}
          </template>
        </a-table>
      </template>

      <template v-slot:money="{ text, record }">
        <span style="color: red">¥{{ record.totalAmount }}</span>
      </template>

      <template v-slot:orderState="{ text, record }">
        {{ record.orderStateValue }}
      </template>

      <template v-slot:operation="{ text, record, index }">
        <a-button class="mb" type="primary" @click="toDetail(record)">
          查看订单
        </a-button>
        <br />
        <!-- v-if="record.orderState == 40" -->
       <!-- <a-button
          v-if="record.orderState == 40"
          class="mb"
          type="primary"
          @click="openModal(record, index)"
        >
          回传订单信息
        </a-button>
        <br />
        <a-button
          v-if="record.orderState == 40"
          type="primary"
          @click="reject(record)"
        >
          驳回
        </a-button>-->
        <!-- <a-button
          type="danger"
          style="margin-left:5px"
          @click="cancel(record)"
          v-if="record.orderState == 30 || record.orderState == 60"
        >
          取消订单
        </a-button> -->
      </template>
    </a-table>
    <!-- </a-card> -->

    <df-pagination :model="pageObj"></df-pagination>

    <a-modal v-model="modalVisible" title="暂停自动出票">
      <!-- @ok="handleOk" -->
      <a-form
        layout="horizontal"
        ref="submitForm"
        :model="submitForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="暂停渠道" prop="companyName">
          <a-input
            v-model="submitForm.companyName"
            placeholder="企业名称"
            style="width: 282px"
          />
        </a-form-item>

        <a-form-item label="结束时间" prop="companyName">
          <a-date-picker
            format="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledDate"
            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 增加选座信息 -->
    <!-- visible1 -->
    <a-modal v-model:visible="visible1" @ok="add" :width="1200">
      <template #title>
        <span>回传订单信息</span>
      </template>
      <a-card title="基本信息" style="overflow:auto">
        <a-form ref="formRef" :model="detail" :rules="offLineRules">
          <a-table
            :columns="columnsBasics"
            :data-source="echoList"
            :pagination="false"
          >
            <template v-slot:isSuccess="{ text, record }">
              <a-form-item>
                <a-select v-model:value="offLineModal.echo">
                  <a-select-option :value="0">是</a-select-option>
                </a-select>
              </a-form-item>
            </template>
            <template v-slot:remarkTitle>
              <a-form-item name="remark">
                <a-input v-model:value="detail.remark"></a-input>
              </a-form-item>
            </template>
            <template v-slot:order>
              <a-form-item name="order">
                <a-input v-model:value="detail.orderCode"></a-input>
              </a-form-item>
            </template>
            <template v-slot:finishTime="{ text, record }">
              <a-form-item name="finishTime">
                <a-input
                  v-if="detail.finishTime"
                  v-model:value="detail.finishTime"
                ></a-input>
                <a-date-picker
                  v-else
                  v-model:value="detail.finishTime"
                  :format="YYYY / MM / DD"
                  valueFormat="YYYY-MM-DD hh:mm:ss"
                />
              </a-form-item>
            </template>
            <template v-slot:startStation="{ text, record }">
              <a-form-item>
                <a-input v-model:value="record.fromStation"></a-input>
              </a-form-item>
            </template>
            <template v-slot:toStation="{ text, record }">
              <a-form-item>
                <a-input v-model:value="record.toStation"></a-input>
              </a-form-item>
            </template>
            <template v-slot:trainNo="{ text, record }">
              <a-form-item>
                {{ record.fromStation }} -> {{ record.toStation
                }}<span style="color: red; margin-left: 10px"
                  >({{ record.trainNo }})</span
                >
              </a-form-item>
            </template>
            <template v-slot:totalAmount="{ text, record }">
              <a-form-item>
                <span style="color: red">¥{{ record.totalAmount }}</span>
              </a-form-item>
            </template>
            <template v-slot:trainDate="{ text, record }">
              <a-form-item> {{ record.trainDate }}</a-form-item>
            </template>
            <template v-slot:seatList>
              <a-form-item>
                <a-input v-model:value="offLineModal.station"></a-input>
              </a-form-item>
            </template>
            <template v-slot:dchooseSeat="{ text, record }">
              <a-form-item name="dchooseSeat">
                <a-select v-model:value="detail.dchooseSeat">
                  <a-select-option value="true">是</a-select-option>
                  <a-select-option value="false">否</a-select-option>
                </a-select>
              </a-form-item>
            </template>
            <template v-slot:extraChooseSeatState>
              <a-form-item name="extraChooseSeatState">
                <a-select v-model:value="detail.extraChooseSeatState">
                  <a-select-option value="true">是</a-select-option>
                  <a-select-option value="false">否</a-select-option>
                </a-select>
              </a-form-item>
            </template>
            <template v-slot:resolveNoSeat>
              <a-form-item>
                <a-select
                  style="width:200px"
                  v-model:value="offLineModal.NoSeat"
                >
                  <a-select-option value="0">是</a-select-option>
                  <a-select-option value="1">否</a-select-option>
                </a-select>
              </a-form-item>
            </template>
            <template v-slot:takeTicket="{ text, record }">
              <a-form-item name="ticketNo">
                <a-input v-model:value="detail.ticketNo"></a-input>
              </a-form-item>
            </template>
          </a-table>
        </a-form>
      </a-card>
      <div style="height:20px"></div>
      <a-card title="服务列表" style="overflow:auto">
        <a-table
          :columns="columnsBasics1"
          :data-source="echoList"
          :pagination="false"
        >
          <template v-slot:isSuccess>
            <a-select style="width:200px" v-model="offLineModal.echo">
              <a-select-option :value="0">是</a-select-option>
              <a-select-option :value="1">否</a-select-option>
            </a-select>
          </template>
          <template v-slot:remarkTitle>
            <a-select style="width:200px" v-model:value="offLineModal.echo1">
              <a-select-option value="是">是</a-select-option>
              <a-select-option value="否">否</a-select-option>
            </a-select>
          </template>
          <template v-slot:order>
            <a-input v-model="offLineModal.order"></a-input>
          </template>
          <template v-slot:datePicker>
            <a-select style="width:200px" v-model:value="offLineModal.echo2">
              <a-select-option value="true">是</a-select-option>
              <a-select-option value="false">否</a-select-option>
            </a-select>
          </template>
          <template v-slot:startStation>
            <a-select style="width:200px" v-model:value="offLineModal.echo3">
              <a-select-option value="true">是</a-select-option>
              <a-select-option value="false">否</a-select-option>
            </a-select>
          </template>
          <template v-slot:endStation>
            <a-input v-model="offLineModal.station"></a-input>
          </template>
          <template v-slot:trainNumber>
            <a-input v-model="offLineModal.station"></a-input>
          </template>
        </a-table>
      </a-card>
      <div style="height:20px"></div>
      <a-card title="乘客信息" style="overflow:auto">
        <a-form
          ref="formRef2"
          :model="detail.passengersList[0]"
          :rules="offLineRules"
        >
          <a-table
            :columns="columnsBasics2"
            :data-source="detail.passengersList"
            :pagination="false"
          >
            <template v-slot:passengerId="{ text, record }">
              <a-form-item name="passengerId">
                <a-input v-model:value="record.passengerId"></a-input>
              </a-form-item>
            </template>
            <template v-slot:passengerType="{ text, record }">
              <a-form-item>
                <a-select v-model:value="record.passengerType">
                  <a-select-option :value="1">成人</a-select-option>
                  <a-select-option :value="2">儿童</a-select-option>
                </a-select>
              </a-form-item>
            </template>
            <template v-slot:passengerName="{ text, record }">
              <a-form-item>
                <a-input v-model:value="record.passengerName"></a-input>
              </a-form-item>
            </template>
            <template v-slot:cardNo="{ text, record }">
              <a-form-item>
                <a-input v-model:value="record.cardNo"></a-input>
              </a-form-item>
            </template>
            <template v-slot:cardType="{ text, record, index }">
              <a-form-item>
                <a-select v-model:value="record.cardType">
                  <a-select-option :value="1">身份证</a-select-option>
                  <a-select-option :value="2">护照</a-select-option>
                </a-select>
              </a-form-item>
            </template>
            <template v-slot:seatClass="{ text, record, index }">
              <a-form-item>
                <a-input v-model="record.seatClass"></a-input>
              </a-form-item>
            </template>
            <template v-slot:lastSeat="{ text, record, index }">
              <a-form-item name="lastSeat">
                <a-input v-model:value="record.lastSeat"></a-input>
              </a-form-item>
            </template>
            <template v-slot:lastCoach="{ text, record, index }">
              <a-form-item name="lastCoach">
                <a-input v-model:value="record.lastCoach"></a-input>
              </a-form-item>
            </template>
            <template v-slot:ticketCheck="{ text, record, index }">
              <a-form-item name="ticketCheck">
                <a-input v-model:value="record.ticketCheck"></a-input>
              </a-form-item>
            </template>
            <template v-slot:ticketSalePrice="{ text, record, index }">
              <a-form-item>
                <span style="color:red">￥{{ record.ticketLastPrice }}</span>
              </a-form-item>
            </template>
            <!-- 测试 -->
            <template v-slot:ticketNo="{ text, record, index }">
              <a-form-item name="ticketNo">
                <a-input v-model:value="record.ticketNo"></a-input>
              </a-form-item>
            </template>
          </a-table>
        </a-form>
      </a-card>
    </a-modal>
    <!-- 驳回弹出框 -->
    <a-modal
      v-model:visible="rejectModal"
      title="是否驳回该订单"
      ok-text="确认"
      cancel-text="取消"
      @ok="hideModal"
    >
      <a-textarea
        placeholder="请填写驳回原因"
        v-model:value="rejectRason"
      ></a-textarea>
    </a-modal>
  </div>


    <!-- 导入文件 -->
    <a-modal
            v-model:visible="createVisible"
            title="导入线下票台订单"
            :footer="null"
            :maskClosable="false"
    >
        <a-spin :spinning="createSpinning">
            <a-form layout="inline">
                <a-row
                        type="flex"
                        justify="space-around"
                        align="middle"
                        class="creatRow"
                >
                    <a-col :span="4">
                        <CloudDownloadOutlined />
                    </a-col>
                    <a-col :span="20">
                        <p>填写导入数据信息</p>
                        <p>
                            请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除
                        </p>
                        <p @click="templateDownload" style="color: #1bba79">下载模板</p>
                    </a-col>
                </a-row>
                <a-row
                        type="flex"
                        justify="space-around"
                        align="middle"
                        class="creatRow"
                >
                    <a-col :span="4">
                        <CloudUploadOutlined />
                    </a-col>
                    <a-col :span="20">
                        <p>上传填好的信息表</p>
                        <p>
                            文件后缀名必须为xls 或xlsx
                            （即Excel格式），文件大小不得大于10M，最多支持导入3000条数据
                        </p>
                        <a-upload
                                :fileList="fileList"
                                :remove="handleRemove"
                                :beforeUpload="beforeUpload"
                        >
                            <p class="handle" style="color: #1bba79; font-weight: normal">
                                上传文件
                            </p>
                        </a-upload>
                    </a-col>
                </a-row>
                <a-row
                        type="flex"
                        justify="space-around"
                        align="middle"
                        class="tipRow"
                >
                    <a-col :span="3">
                        <ExclamationCircleOutlined />
                    </a-col>
                    <a-col :span="21">
                        <p>特别提示</p>
                        <p>单号不能重复</p>
                    </a-col>
                </a-row>

                <a-form-item>
                    <a-button type="primary" @click="createCancel"> 取消 </a-button>
                </a-form-item>
                <a-form-item>
                    <a-button @click="handleUpload">上传</a-button>
                </a-form-item>
            </a-form>
        </a-spin>
    </a-modal>

    <!-- 上传成功后的弹出框 -->

    <a-modal
            v-model:visible="uploadDialog"
            :cancel-button-props="{ style: { display: 'none' } }"
            @ok="() => (uploadDialog = false)"
    >
        <div style="font-size:18px">上传成功</div>
        <template slot="footer">
            <a-button
                    type="primary"
                    @click.stop="
            () => {
              uploadDialog = false;
            }
          "
            >返回</a-button
            >
        </template>
    </a-modal>


</template>

<script>
// setInterval(() => {
//   window.location.reload();
// }, 180000);
import orderApi from "@axios/order";
import { exportOut } from "@axios/exportOut";
import moment from "moment";
import {
  reactive,
  ref,
  provide,
  h,
  toRef,
  toRefs,
  nextTick,
  defineAsyncComponent,
} from "vue";
import orderState from "@assets/static";
import { useRouter } from "vue-router";
import { Modal, destroyAll, notification } from "ant-design-vue";
import { DribbbleSquareFilled, SmileOutlined } from "@ant-design/icons-vue";
import {
    CloudDownloadOutlined,
    CloudUploadOutlined,
    ExclamationCircleOutlined,
    UploadOutlined,
} from "@ant-design/icons-vue";
export default {
  name: "offLineTicket",
  components: {
    SmileOutlined,
      CloudDownloadOutlined,
      CloudUploadOutlined,
      ExclamationCircleOutlined,
      UploadOutlined,
  },
  setup() {
    let echoList = ref([]);
    let offLineModal = reactive({
      echo: "是",
      echoo: "否",
      echo1: "",
      echo2: "",
      echo3: "",
      remark: "",
      ticketNo: "", //取票号
      orderCode: "", //订单号
      fromStation: "", //出发站
      toStation: "", //到达站
      finishTime: "", //订票出票时间
      trainNo: "", //车次
      totalAmount: "", //订单总金额
      trainDate: "", //乘车日期
      dchooseSeat: "", //动车高铁选座是否成功
      extraChooseSeatState: "", //另外收费的选座是否成功
      passengerId: "", //乘客ID
      passengerType: "", //乘客类型
      cardNo: "", //证件号
      cardType: "", //证件类型
      seatClass: "", //坐席类别
      lastSeat: "", //座位号
      lastCoach: "", //车厢号
      ticketCheck: "", //检票号
      offLineOrderPassengers: [],
    });
    let formModal = reactive({
      state: "是",
      remark: "",
      createTime: "",
      chengche: "",
      xuanzuochecked: true,
      price: 100,
    });
    //切换回填订单信息 是否成功
    let handleChange = (value) => {
      formModal.value = value;
    };
    const router = useRouter();
    const columnsInner = [
      {
        title: "票号",
        dataIndex: "ticketNo",
        width: 100,
        align: "center",
      },
      {
        title: "购票人",
        dataIndex: "passengerName",
        width: 100,
        align: "center",
      },
      {
        title: "座位",
        dataIndex: "orderCode",
        width: 100,
        align: "center",
        slots: { customRender: "site" },
      },
    ];
    let panes = ref([
      { tab: "全部", key: "0" },
      { tab: "占座中", key: "20" },
      { tab: "占座成功", key: "30" },
      { tab: "出票中", key: "40" },
      { tab: "占座失败", key: "60" },
      { tab: "取消订单", key: "90" },
      { tab: "已出票", key: "50" },
    ]);
    let modalVisible = ref(false);
    let visible = ref(false);
    let loading = ref(false);
    let submitForm = reactive({});
    let searchForm = reactive({
      distributorId: undefined,
      code: "",
      passenger: "",
      date: [],
      orderdate: [],
      from: "",
      to: "",
    });
    let searchParams = reactive({
      distributorId: undefined,
      code: "",
      passenger: "",
      date: [],
      orderdate: [],
      from: "",
      to: "",
    });
    let list = ref([]);
    let testList = ref([]);
    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });

    let activeKey = ref("0");

    const pageChange = (page) => {
      pageObj.value.page = page;
      getList();
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      getList();
    };

    const cardtabChange = (key) => {
      activeKey.value = key;
      reset();
    };

    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);

    const searchAction = () => {
      searchParams.distributorId = searchForm.distributorId;
      searchParams.code = searchForm.code;
      searchParams.date = searchForm.date;
      searchParams.orderdate = searchForm.orderdate;
      searchParams.from = searchForm.from;
      searchParams.to = searchForm.to;

      pageObj.value = {
        page: 1,
        rows: 10,
        totle: 1,
      };
      getList();
    };

    const getList = () => {
      loading.value = true;
      let params = {
        distributorId: searchParams.distributorId,
        orderState: activeKey.value == "0" ? null : activeKey.value,
        fromStation: searchParams.from ? searchParams.from : null,
        toStation: searchParams.to ? searchParams.to : null,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
      };

      if (searchParams.orderdate.length) {
        params.orderBeginTime = searchParams.orderdate[0];
        params.orderEndTime = searchParams.orderdate[1];
      }

      if (searchParams.date.length) {
        params.finishBeginTime = searchParams.date[0];
        params.finishEndTime = searchParams.date[1];
      }
      if (searchParams.code) {
        if (codeType.value == "订单编号") {
          params.code = searchParams.code;
        } else if (codeType.value == "顾客姓名") {
          params.passengerName = searchParams.code;
        } else {
          params.mobile = searchParams.code;
        }
      }

      getCount(params);

      orderApi.getOffLineList(params).then((res) => {
        loading.value = false;
        if (!res) return;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.page;
        list.value = res.data;
      });
    };

    const getCount = (params) => {
      orderApi.orderCount(params).then((res) => {
        panes.value = [
          { tab: "全部", key: "0" },
          { tab: "占座中", key: "20" },
          { tab: "占座成功", key: "30" },
          { tab: "出票中", key: "40" },
          { tab: "占座失败", key: "60" },
          { tab: "取消订单", key: "90" },
          { tab: "已出票", key: "50" },
        ];

        let sum = 0;
        for (var key in res) {
          sum += res[key];
        }

        panes.value.forEach((element) => {
          if (element.key != "0" && res["count" + element.key]) {
            element.tab =
              element.tab + " ( " + res["count" + element.key] + " ) ";
          } else if (element.key == "0" && sum) {
            element.tab = element.tab + " ( " + sum + " ) ";
          }
        });
      });
    };

    const reset = () => {
      searchForm.code = "";
      searchForm.date = [];
      searchForm.orderdate = [];
      searchForm.from = "";
      searchForm.to = "";
      searchAction();
    };

    const toDetail = (row) => {
      router.push({
        name: "orderDetail",
        query: {
          code: row.orderCode,
          type: "nomalOrder",
          flag: "8",
        },
      });
    };

    const cancel = (row) => {
      Modal.confirm({
        content: "是否确定取消该订单？",
        onOk() {
          let params = {
            orderCode: row.orderCode,
          };
          orderApi.orderConcel(params).then((res) => {
            notification.open({
              message: "取消成功",
              icon: <SmileOutlined style="color: #108ee9" />,
            });
            getList();
          });
        },
        cancelText: "取消",
        okText: "确定",
        onCancel() {
          Modal.destroyAll();
        },
      });
    };

    const setValue = (v) => {
      if (v.title == "始发站") {
        searchForm.from = v.val;
      } else {
        searchForm.to = v.val;
      }
    };

    let codeType = ref("订单编号");

    getList();

    //打开弹出框
    let passengersList = ref([]);
    let visible1 = ref(false);
    let detail = reactive({});
    let openModal = (record) => {
      orderApi.getOrderDetail(record.orderCode).then((res) => {
        Object.keys(res).forEach((item) => {
          detail[item] = res[item];
          // detail.ticketNo = "22";
        });
        visible1.value = true;
        echoList.value = [];
        echoList.value.push(res);
      });
    };
    //作废
    let rejectModal = ref(false);
    let rejectRason = ref(""); //驳回原因
    let orderCode = ref("");
    let reject = (record) => {
      orderCode.value = record.orderCode;
      rejectRason.value = "";
      rejectModal.value = true;
      return;
      Modal.confirm({
        title: "是否驳回该订单",
        icon: createVNode(ExclamationCircleOutlined),
        okText: "确认",
        cancelText: "取消",
        content: () => {
          h(
            "div",
            {
              style: "color:red;",
            },
            "Some descriptions"
          );
        },
        onOk: () => {
          alert("点击后请求后台逻辑");
        },
      });
    };

    //点击驳回确定按钮像后台返送请求
    let hideModal = () => {
      let params = {
        orderCode: orderCode.value,
        remark: rejectRason.value,
      };
      orderApi
        .reject(params)
        .then((res) => {
          if (res.code == 200) {
            notification.success({
              message: "驳回成功",
            });
            rejectModal.value = false;
            getList();
          }
        })
        .catch((e) => {
          notification.error({
            message: e.message,
          });
        });
    };
    //增加回填信息

    const formRef = ref(); //基础信息校验
    const formRef2 = ref(); //乘客信息校验
    let add = async () => {
      let params = {
        orderCode: detail.orderCode,
        remark: detail.remark,
        finishTime: detail.finishTime,
        dchooseSeat: detail.dchooseSeat,
        extraChooseSeatState: detail.extraChooseSeatState,
        ticketNo: detail.ticketNo,
        fromStation: detail.fromStation,
        toStation: detail.toStation,
        trainNo: detail.trainNo,
        totalAmount: detail.totalAmount,
        trainDate: detail.trainDate,
        ticketGate: detail.passengersList[0].ticketCheck,
        offLineOrderPassengers: detail.passengersList,
      };
      //回填参数
      let result = await formRef.value.validate().catch((e) => {});
      result = result ? await formRef2.value.validate().catch((e) => {}) : "";
      result = result
        ? await orderApi
            .getOffLine(params)
            .catch((e) => notification.error({ message: e.message }))
        : "";
      result.code == 200
        ? notification.success({
            message: "回填成功",
          }) && getList()
        : "";
      return;
      //promise
      formRef.value
        .validate()
        .then((res) => {
          formRef2.value
            .validate()
            .then((res) => {
              orderApi
                .getOffLine(params)
                .then((res) => {
                  if (res.code == 200) {
                    notification.success({
                      message: "回填成功",
                    });
                    getList();
                  }
                })
                .catch((e) => {
                  notification.error({
                    message: e.message,
                  });
                });
            })
            .catch((e) => {
              console.log("乘客信息校验失败", e);
            });
        })
        .catch((e) => console.log(e, "失败"));
    };

    //回填信息校验
    const offLineRules = {
      echo: [
        {
          required: true,
          message: "请选择是否成功",
          trigger: "blur",
        },
      ],
      remark: [
        //订单提示信息
        {
          required: true,
          message: "请填写订单提示信息",
          trigger: "blur",
        },
      ],
      order: [
        //订单号
        {
          required: false,
          message: "请填写订单号",
        },
      ],
      ticketNo: [
        //取票号
        {
          required: true,
          message: "请填写取票号",
          trigger: "blur",
        },
      ],
      fromStation: [
        //出发站
        {
          required: false,
        },
      ],
      toStation: [
        //到达站
        {
          required: false,
        },
      ],
      finishTime: [
        //订票出票时间
        {
          required: true,
          message: "请选择订票出票时间",
          trigger: "blur",
        },
      ],
      trainNo: [
        //车次
        {
          required: false,
        },
      ],
      totalAmount: [
        //订单总金额
        {
          required: true,
          message: "请填写订单总金额",
          trigger: "blur",
        },
      ],
      trainDate: [
        //乘车日期
        {
          required: false,
        },
      ],
      dchooseSeat: [
        //动车高铁选座是否成功
        {
          required: true,
          message: "请选择",
          trigger: "blur",
        },
      ],
      extraChooseSeatState: [
        //另外收费的选座是否成功
        {
          required: true,
          message: "请选择",
          trigger: "blur",
        },
      ],
      lastSeat: [
        //座位号
        {
          required: true,
          message: "请填写座位号",
          trigger: "blur",
        },
      ],
      lastCoach: [
        //车厢号
        {
          required: true,
          message: "请填写车厢号",
          trigger: "blur",
        },
      ],
      ticketNo: [
        //客票票号
        {
          required: true,
          message: "请填写车票号",
          trigger: "blur",
        },
      ],
    };
    const offLineRules1 = {
      ticketNo: [
        //客票票号
        {
          required: true,
          message: "请填写车票号",
          trigger: "blur",
        },
      ],
    };
     // ------ lemon 新增的开始-----------
      let uploadDialog = ref(false);
      let fileList = ref([]);
      const handleRemove = (file) => {
          // 移除文件时，要重新给fileList赋值
          let arr = [];
          for (let i = 0; i < fileList.value.length; i++) {
              if (fileList.value[i].uid !== file.uid) {
                  arr.push(fileList.value[i]);
              }
          }
          fileList.value = arr;
          console.log(fileList.value);
      };
        // 上传前校验
      const beforeUpload = (file) => {
          console.log(file);
          // const isXlsOrXlsx = file.type === "xls" || file.type === "xlsx";
          // if (!isXlsOrXlsx) {
          //   message.error("只能上传xls 或xlsx （即Excel格式）!");
          // }
          // const isLt10M = file.size / 1024 / 1024 < 10;
          // if (!isLt10M) {
          //   message.error("文件大小不得大于10M!");
          // }
          // return isXlsOrXlsx && isLt10M;
          fileList.value = [...fileList.value, file];
          return false;
      };
      //上传文件
      let createVisible = ref(false);
      // loading
      let createSpinning = ref(false);
      const createBill = () => {
          createVisible.value = true;
      };

      // 上传
      const handleUpload = () => {
          if (fileList.value == "") return;
          createSpinning.value = true;
          console.log(fileList.value);
          const formData = new FormData();
          fileList.value.forEach((file) => {
              formData.append("file", file);
              console.log(file);
          });
          orderApi.createOffLine(formData).then((res) => {
              console.log(res, "上传");
              fileList.value = [];
              // message.success("上传成功");
              setTimeout(() => {
                  createSpinning.value = false;
                  uploadDialog.value = true;
                  createVisible.value = false;
              }, 3000);
              query();
          });
      };
      const createCancel = () => {
          createVisible.value = false;
      };

      // 下载模板
      const templateDownload = () => {
          let params = {};
          let fileName = "模板";
          exportOut(
              params, // 导出请求参数
              "/app-admin/offLineOrder/download/template", // 接口地址
              fileName // 导出文件名字
          );
      };

      // ------ lemon 新增的结束-----------

    return {
      orderCode,
      detail,
      passengersList,
      offLineModal,
      offLineRules,
      offLineRules1,
        // ------ lemon 新增的开始-----------
        createBill,
        createVisible,
        uploadDialog,
        createSpinning,
        fileList,
        handleRemove,
        beforeUpload,
        handleUpload,
        createCancel,
        templateDownload,

        // ------ lemon 新增的结束-----------
      testList,
      echoList,
      rejectRason,
      hideModal,
      rejectModal,
      handleChange,
      formRef,
      formRef2,
      add,
      formModal,
      reject,
      visible1,
      openModal,
      setValue,
      codeType,
      cancel,
      panes,
      reset,
      searchAction,
      activeKey: activeKey,
      modalVisible,
      visible,
      loading,
      submitForm,
      list,
      rules: {
        state: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      stateList: [
        {
          name: "供应",
          val: 10,
        },
        {
          name: "渠道",
          val: 20,
        },
      ],
      columnsBasics: [
        {
          title: "是否成功",
          width: 200,
          slots: {
            customRender: "isSuccess",
          },
        },
        {
          title: "订单提示信息",
          width: 200,
          slots: {
            customRender: "remarkTitle",
          },
        },
        {
          title: "订单号",
          width: 200,
          slots: {
            customRender: "order",
          },
        },
        {
          title: "订单出票时间",
          width: 200,
          slots: {
            customRender: "finishTime",
          },
        },
        {
          title: "出发站",
          width: 200,
          slots: {
            customRender: "startStation",
          },
        },
        {
          title: "到达站",
          width: 200,
          slots: {
            customRender: "toStation",
          },
        },
        {
          title: "车次",
          width: 200,
          slots: {
            customRender: "trainNo",
          },
        },
        {
          title: "订单总金额",
          width: 200,
          slots: {
            customRender: "totalAmount",
          },
        },
        {
          title: "乘车日期",
          width: 200,
          slots: {
            customRender: "trainDate",
          },
        },
        {
          title: "动车高铁选座列表",
          width: 200,
          slots: {
            customRender: "seatList",
          },
        },
        {
          title: "动车高铁选座是否成功",
          width: 200,
          slots: {
            customRender: "dchooseSeat",
          },
        },
        {
          title: "另外收费的选座是否成功",
          width: 200,
          slots: {
            customRender: "extraChooseSeatState",
          },
        },
        {
          title: "是否接受无座",
          width: 200,
          slots: {
            customRender: "resolveNoSeat",
          },
        },
        {
          title: "取票号",
          width: 200,
          slots: {
            customRender: "takeTicket",
          },
        },
      ],
      columnsBasics1: [
        {
          title: "是否同车厢",
          width: 200,
          slots: {
            customRender: "isSuccess",
          },
        },
        {
          title: "是否同包厢",
          width: 200,
          slots: {
            customRender: "remarkTitle",
          },
        },
        {
          title: "选座列表",
          width: 200,
          slots: {
            customRender: "order",
          },
        },
        {
          title: "是否选面对面座位",
          width: 200,
          slots: {
            customRender: "datePicker",
          },
        },
        {
          title: "是否选同排",
          width: 200,
          slots: {
            customRender: "startStation",
          },
        },
        {
          title: "高铁动车选座列表",
          width: 200,
          slots: {
            customRender: "endStation",
          },
        },
        {
          title: "选铺位列表",
          width: 200,
          slots: {
            customRender: "trainNumber",
          },
        },
      ],
      columnsBasics2: [
        {
          title: "乘客ID",
          width: 200,
          slots: {
            customRender: "passengerId",
          },
        },
        {
          title: "乘客类型",
          width: 200,
          slots: {
            customRender: "passengerType",
          },
        },
        {
          title: "乘客姓名",
          width: 200,
          slots: {
            customRender: "passengerName",
          },
        },
        {
          title: "证件号",
          width: 200,
          slots: {
            customRender: "cardNo",
          },
        },
        {
          title: "证件类型",
          width: 200,
          slots: {
            customRender: "cardType",
          },
        },
        {
          title: "坐席类别",
          width: 200,
          slots: {
            customRender: "seatClass",
          },
        },
        {
          title: "座位号",
          width: 200,
          slots: {
            customRender: "lastSeat",
          },
        },
        {
          title: "车厢号",
          width: 200,
          slots: {
            customRender: "lastCoach",
          },
        },
        {
          title: "检票口",
          width: 200,
          slots: {
            customRender: "ticketCheck",
          },
        },
        {
          title: "车票价格",
          width: 200,
          slots: {
            customRender: "ticketSalePrice",
          },
        },
        {
          title: "客票票号",
          width: 200,
          dataIndex: "ticketNo",
          slots: {
            customRender: "ticketNo",
          },
        },
      ],
      columns: [
        {
          title: "订单编号",
          dataIndex: "orderCode",
          width: 200,
          align: "center",
          slots: { customRender: "orderCode" },
        },
        {
          title: "车票类型",
          dataIndex: "typeValue",
          width: 100,
          align: "center",
        },
        {
          title: "车次信息",
          dataIndex: "mobile",
          width: 300,
          align: "left",
          slots: { customRender: "train" },
        },
        {
          title: "票号/购票人/座位",
          dataIndex: "taxpayerNum",
          width: 400,
          align: "center",
          slots: { customRender: "passengersList" },
        },
        {
          title: "订单金额",
          dataIndex: "stateName",
          width: 100,
          align: "center",
          slots: { customRender: "money" },
        },
        {
          title: "渠道",
          dataIndex: "distributorName",
          width: 100,
          align: "center",
        },
        {
          title: "提交时间",
          dataIndex: "createTime",
          width: 150,
          align: "center",
        },
        {
          title: "订单状态",
          dataIndex: "22",
          width: 150,
          align: "center",
          slots: { customRender: "orderState" },
        },
        {
          title: "操作",
          align: "center",
          dataIndex: "operation",
          key: "operation",
          width: 220,
          slots: { customRender: "operation" },
        },
      ],
      searchForm,
      searchParams,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      moment,
      pageObj,
      disabledDate(current) {
        // Can not select days before today and today

        return current && current < moment().endOf("day");
      },
      cardtabChange,
      columnsInner,
      orderState,
      toDetail,
      rules8: {
        aotu: [
          {
            required: true,
            message: "请选择是否自动兑换",
            trigger: "blur",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入订单金额",
            trigger: "blur",
          },
        ],
        createOrderTime: [
          {
            required: true,
            message: "请输入订单出票时间",
            trigger: "blur",
          },
        ],
        textarea: [
          {
            required: true,
            message: "请输入提示信息",
            trigger: "blur",
          },
        ],
        surnameEn: [
          {
            required: true,
            message: "请输入英文姓",
            trigger: "blur",
          },
        ],
        givenNameEn: [
          {
            required: true,
            message: "请输入英文名",
            trigger: "blur",
          },
        ],
        distributorId: [
          {
            required: true,
            message: "请选择渠道名称",
            trigger: "blur",
          },
        ],
        distributorOrderId: [
          {
            required: true,
            message: "请填写渠道订单号",
            trigger: "blur",
          },
        ],
        supplierOrderId: [
          {
            required: true,
            message: "请填写积分平台订单号",
            trigger: "blur",
          },
        ],
        carrier: [
          {
            required: true,
            message: "请选择积分名称",
            trigger: "blur",
          },
        ],

        payAmount: [
          {
            required: true,
            message: "请填写交易金额",
            trigger: "blur",
          },
        ],
        amount: [
          {
            required: true,
            message: "请填写积分数额",
            trigger: "blur",
          },
        ],
        memberId: [
          {
            required: true,
            message: "请填写积分平台会员ID",
            trigger: "blur",
          },
        ],
      },
    };
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.log_content /deep/ .ant-card-extra {
  float: none;
  margin-left: 0;
}
/deep/ .ant-tabs-tab-active {
  color: #1abc9c !important;
}
/deep/ .ant-tabs-tab:hover {
  color: #1abc9c !important;
}
/deep/ .ant-tabs-ink-bar {
  background-color: #1abc9c !important;
}
.mb {
  margin-bottom: 10px;
}
</style>
